// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1VBMa","footer":"ModalUpdate_footer__1254q"};